// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file pinix/v2/hub.proto (package pinix.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pinix/v2/hub.proto.
 */
export const file_pinix_v2_hub: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message pinix.v2.HubError
 */
export type HubError = Message<"pinix.v2.HubError"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message pinix.v2.HubError.
 * Use `create(HubErrorSchema)` to create a new message.
 */
export const HubErrorSchema: GenMessage<HubError> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 0);

/**
 * @generated from message pinix.v2.CommandInfo
 */
export type CommandInfo = Message<"pinix.v2.CommandInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string input = 3;
   */
  input: string;

  /**
   * @generated from field: string output = 4;
   */
  output: string;
};

/**
 * Describes the message pinix.v2.CommandInfo.
 * Use `create(CommandInfoSchema)` to create a new message.
 */
export const CommandInfoSchema: GenMessage<CommandInfo> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 1);

/**
 * @generated from message pinix.v2.ClipInfo
 */
export type ClipInfo = Message<"pinix.v2.ClipInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string package = 2;
   */
  package: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string provider = 4;
   */
  provider: string;

  /**
   * @generated from field: string domain = 5;
   */
  domain: string;

  /**
   * @generated from field: repeated pinix.v2.CommandInfo commands = 6;
   */
  commands: CommandInfo[];

  /**
   * @generated from field: bool has_web = 7;
   */
  hasWeb: boolean;

  /**
   * @generated from field: bool token_protected = 8;
   */
  tokenProtected: boolean;

  /**
   * @generated from field: repeated string dependencies = 9;
   */
  dependencies: string[];

  /**
   * @generated from field: pinix.v2.ClipStatus status = 10;
   */
  status: ClipStatus;

  /**
   * @generated from field: string status_message = 11;
   */
  statusMessage: string;
};

/**
 * Describes the message pinix.v2.ClipInfo.
 * Use `create(ClipInfoSchema)` to create a new message.
 */
export const ClipInfoSchema: GenMessage<ClipInfo> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 2);

/**
 * @generated from message pinix.v2.DependencySlot
 */
export type DependencySlot = Message<"pinix.v2.DependencySlot"> & {
  /**
   * @generated from field: string package = 1;
   */
  package: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message pinix.v2.DependencySlot.
 * Use `create(DependencySlotSchema)` to create a new message.
 */
export const DependencySlotSchema: GenMessage<DependencySlot> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 3);

/**
 * @generated from message pinix.v2.ClipBinding
 */
export type ClipBinding = Message<"pinix.v2.ClipBinding"> & {
  /**
   * @generated from field: string alias = 1;
   */
  alias: string;

  /**
   * @generated from field: string hub = 2;
   */
  hub: string;

  /**
   * @generated from field: string hub_token = 3;
   */
  hubToken: string;

  /**
   * @generated from field: string clip_token = 4;
   */
  clipToken: string;
};

/**
 * Describes the message pinix.v2.ClipBinding.
 * Use `create(ClipBindingSchema)` to create a new message.
 */
export const ClipBindingSchema: GenMessage<ClipBinding> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 4);

/**
 * @generated from message pinix.v2.ClipManifest
 */
export type ClipManifest = Message<"pinix.v2.ClipManifest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string package = 2;
   */
  package: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated pinix.v2.CommandInfo commands = 6;
   */
  commands: CommandInfo[];

  /**
   * @generated from field: repeated string dependencies = 7;
   */
  dependencies: string[];

  /**
   * @generated from field: bool has_web = 8;
   */
  hasWeb: boolean;

  /**
   * @generated from field: repeated string patterns = 9;
   */
  patterns: string[];

  /**
   * @generated from field: map<string, string> entities = 10;
   */
  entities: { [key: string]: string };

  /**
   * @generated from field: map<string, pinix.v2.DependencySlot> dependency_slots = 11;
   */
  dependencySlots: { [key: string]: DependencySlot };
};

/**
 * Describes the message pinix.v2.ClipManifest.
 * Use `create(ClipManifestSchema)` to create a new message.
 */
export const ClipManifestSchema: GenMessage<ClipManifest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 5);

/**
 * 当前连入的 Provider（在列表里 = 在线）。
 *
 * @generated from message pinix.v2.ProviderInfo
 */
export type ProviderInfo = Message<"pinix.v2.ProviderInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool accepts_manage = 2;
   */
  acceptsManage: boolean;

  /**
   * @generated from field: repeated string clips = 3;
   */
  clips: string[];

  /**
   * @generated from field: int64 connected_at = 4;
   */
  connectedAt: bigint;
};

/**
 * Describes the message pinix.v2.ProviderInfo.
 * Use `create(ProviderInfoSchema)` to create a new message.
 */
export const ProviderInfoSchema: GenMessage<ProviderInfo> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 6);

/**
 * @generated from message pinix.v2.ClipStatusChanged
 */
export type ClipStatusChanged = Message<"pinix.v2.ClipStatusChanged"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: pinix.v2.ClipStatus status = 2;
   */
  status: ClipStatus;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message pinix.v2.ClipStatusChanged.
 * Use `create(ClipStatusChangedSchema)` to create a new message.
 */
export const ClipStatusChangedSchema: GenMessage<ClipStatusChanged> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 7);

/**
 * @generated from message pinix.v2.ProviderMessage
 */
export type ProviderMessage = Message<"pinix.v2.ProviderMessage"> & {
  /**
   * @generated from oneof pinix.v2.ProviderMessage.payload
   */
  payload: {
    /**
     * @generated from field: pinix.v2.RegisterRequest register = 1;
     */
    value: RegisterRequest;
    case: "register";
  } | {
    /**
     * @generated from field: pinix.v2.ClipAdded clip_added = 2;
     */
    value: ClipAdded;
    case: "clipAdded";
  } | {
    /**
     * @generated from field: pinix.v2.ClipRemoved clip_removed = 3;
     */
    value: ClipRemoved;
    case: "clipRemoved";
  } | {
    /**
     * @generated from field: pinix.v2.InvokeResult invoke_result = 4;
     */
    value: InvokeResult;
    case: "invokeResult";
  } | {
    /**
     * @generated from field: pinix.v2.Heartbeat ping = 5;
     */
    value: Heartbeat;
    case: "ping";
  } | {
    /**
     * @generated from field: pinix.v2.GetClipWebResult get_clip_web_result = 7;
     */
    value: GetClipWebResult;
    case: "getClipWebResult";
  } | {
    /**
     * @generated from field: pinix.v2.ClipStatusChanged clip_status_changed = 8;
     */
    value: ClipStatusChanged;
    case: "clipStatusChanged";
  } | {
    /**
     * @generated from field: pinix.v2.DataResult data_result = 9;
     */
    value: DataResult;
    case: "dataResult";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pinix.v2.ProviderMessage.
 * Use `create(ProviderMessageSchema)` to create a new message.
 */
export const ProviderMessageSchema: GenMessage<ProviderMessage> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 8);

/**
 * @generated from message pinix.v2.HubMessage
 */
export type HubMessage = Message<"pinix.v2.HubMessage"> & {
  /**
   * @generated from oneof pinix.v2.HubMessage.payload
   */
  payload: {
    /**
     * @generated from field: pinix.v2.RegisterResponse register_response = 1;
     */
    value: RegisterResponse;
    case: "registerResponse";
  } | {
    /**
     * @generated from field: pinix.v2.InvokeCommand invoke_command = 2;
     */
    value: InvokeCommand;
    case: "invokeCommand";
  } | {
    /**
     * @generated from field: pinix.v2.InvokeInput invoke_input = 3;
     */
    value: InvokeInput;
    case: "invokeInput";
  } | {
    /**
     * @generated from field: pinix.v2.Heartbeat pong = 5;
     */
    value: Heartbeat;
    case: "pong";
  } | {
    /**
     * @generated from field: pinix.v2.GetClipWebCommand get_clip_web_command = 6;
     */
    value: GetClipWebCommand;
    case: "getClipWebCommand";
  } | {
    /**
     * @generated from field: pinix.v2.DataCommand data_command = 7;
     */
    value: DataCommand;
    case: "dataCommand";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pinix.v2.HubMessage.
 * Use `create(HubMessageSchema)` to create a new message.
 */
export const HubMessageSchema: GenMessage<HubMessage> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 9);

/**
 * @generated from message pinix.v2.RuntimeMessage
 */
export type RuntimeMessage = Message<"pinix.v2.RuntimeMessage"> & {
  /**
   * @generated from oneof pinix.v2.RuntimeMessage.payload
   */
  payload: {
    /**
     * @generated from field: pinix.v2.RuntimeRegister register = 1;
     */
    value: RuntimeRegister;
    case: "register";
  } | {
    /**
     * @generated from field: pinix.v2.InstallResult install_result = 2;
     */
    value: InstallResult;
    case: "installResult";
  } | {
    /**
     * @generated from field: pinix.v2.RemoveResult remove_result = 3;
     */
    value: RemoveResult;
    case: "removeResult";
  } | {
    /**
     * @generated from field: pinix.v2.Heartbeat ping = 4;
     */
    value: Heartbeat;
    case: "ping";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pinix.v2.RuntimeMessage.
 * Use `create(RuntimeMessageSchema)` to create a new message.
 */
export const RuntimeMessageSchema: GenMessage<RuntimeMessage> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 10);

/**
 * @generated from message pinix.v2.HubRuntimeMessage
 */
export type HubRuntimeMessage = Message<"pinix.v2.HubRuntimeMessage"> & {
  /**
   * @generated from oneof pinix.v2.HubRuntimeMessage.payload
   */
  payload: {
    /**
     * @generated from field: pinix.v2.RuntimeRegisterResponse register_response = 1;
     */
    value: RuntimeRegisterResponse;
    case: "registerResponse";
  } | {
    /**
     * @generated from field: pinix.v2.InstallCommand install_command = 2;
     */
    value: InstallCommand;
    case: "installCommand";
  } | {
    /**
     * @generated from field: pinix.v2.RemoveCommand remove_command = 3;
     */
    value: RemoveCommand;
    case: "removeCommand";
  } | {
    /**
     * @generated from field: pinix.v2.Heartbeat pong = 4;
     */
    value: Heartbeat;
    case: "pong";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pinix.v2.HubRuntimeMessage.
 * Use `create(HubRuntimeMessageSchema)` to create a new message.
 */
export const HubRuntimeMessageSchema: GenMessage<HubRuntimeMessage> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 11);

/**
 * @generated from message pinix.v2.RegisterRequest
 */
export type RegisterRequest = Message<"pinix.v2.RegisterRequest"> & {
  /**
   * @generated from field: string provider_name = 1;
   */
  providerName: string;

  /**
   * @generated from field: repeated pinix.v2.ClipRegistration clips = 3;
   */
  clips: ClipRegistration[];
};

/**
 * Describes the message pinix.v2.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 12);

/**
 * @generated from message pinix.v2.ClipRegistration
 */
export type ClipRegistration = Message<"pinix.v2.ClipRegistration"> & {
  /**
   * @generated from field: string alias = 1;
   */
  alias: string;

  /**
   * @generated from field: string package = 2;
   */
  package: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * @generated from field: repeated pinix.v2.CommandInfo commands = 5;
   */
  commands: CommandInfo[];

  /**
   * @generated from field: bool has_web = 6;
   */
  hasWeb: boolean;

  /**
   * @generated from field: repeated string dependencies = 7;
   */
  dependencies: string[];

  /**
   * @generated from field: bool token_protected = 8;
   */
  tokenProtected: boolean;

  /**
   * @generated from field: string name = 9 [deprecated = true];
   * @deprecated
   */
  name: string;

  /**
   * @generated from field: repeated string patterns = 10;
   */
  patterns: string[];

  /**
   * @generated from field: map<string, string> entities = 11;
   */
  entities: { [key: string]: string };
};

/**
 * Describes the message pinix.v2.ClipRegistration.
 * Use `create(ClipRegistrationSchema)` to create a new message.
 */
export const ClipRegistrationSchema: GenMessage<ClipRegistration> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 13);

/**
 * @generated from message pinix.v2.ClipAdded
 */
export type ClipAdded = Message<"pinix.v2.ClipAdded"> & {
  /**
   * @generated from field: pinix.v2.ClipRegistration clip = 1;
   */
  clip?: ClipRegistration;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;
};

/**
 * Describes the message pinix.v2.ClipAdded.
 * Use `create(ClipAddedSchema)` to create a new message.
 */
export const ClipAddedSchema: GenMessage<ClipAdded> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 14);

/**
 * @generated from message pinix.v2.ClipRemoved
 */
export type ClipRemoved = Message<"pinix.v2.ClipRemoved"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;
};

/**
 * Describes the message pinix.v2.ClipRemoved.
 * Use `create(ClipRemovedSchema)` to create a new message.
 */
export const ClipRemovedSchema: GenMessage<ClipRemoved> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 15);

/**
 * @generated from message pinix.v2.InvokeResult
 */
export type InvokeResult = Message<"pinix.v2.InvokeResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bytes output = 2;
   */
  output: Uint8Array;

  /**
   * @generated from field: pinix.v2.HubError error = 3;
   */
  error?: HubError;

  /**
   * @generated from field: bool done = 4;
   */
  done: boolean;
};

/**
 * Describes the message pinix.v2.InvokeResult.
 * Use `create(InvokeResultSchema)` to create a new message.
 */
export const InvokeResultSchema: GenMessage<InvokeResult> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 16);

/**
 * @generated from message pinix.v2.GetClipWebCommand
 */
export type GetClipWebCommand = Message<"pinix.v2.GetClipWebCommand"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string clip_name = 2;
   */
  clipName: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: int64 offset = 4;
   */
  offset: bigint;

  /**
   * @generated from field: int64 length = 5;
   */
  length: bigint;

  /**
   * @generated from field: string if_none_match = 6;
   */
  ifNoneMatch: string;
};

/**
 * Describes the message pinix.v2.GetClipWebCommand.
 * Use `create(GetClipWebCommandSchema)` to create a new message.
 */
export const GetClipWebCommandSchema: GenMessage<GetClipWebCommand> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 17);

/**
 * @generated from message pinix.v2.GetClipWebResult
 */
export type GetClipWebResult = Message<"pinix.v2.GetClipWebResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: string etag = 4;
   */
  etag: string;

  /**
   * @generated from field: int64 total_size = 5;
   */
  totalSize: bigint;

  /**
   * @generated from field: bool not_modified = 6;
   */
  notModified: boolean;

  /**
   * @generated from field: pinix.v2.HubError error = 7;
   */
  error?: HubError;
};

/**
 * Describes the message pinix.v2.GetClipWebResult.
 * Use `create(GetClipWebResultSchema)` to create a new message.
 */
export const GetClipWebResultSchema: GenMessage<GetClipWebResult> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 18);

/**
 * @generated from message pinix.v2.RegisterResponse
 */
export type RegisterResponse = Message<"pinix.v2.RegisterResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message pinix.v2.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 19);

/**
 * @generated from message pinix.v2.RuntimeRegister
 */
export type RuntimeRegister = Message<"pinix.v2.RuntimeRegister"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string hostname = 2;
   */
  hostname: string;

  /**
   * @generated from field: string os = 3;
   */
  os: string;

  /**
   * @generated from field: string arch = 4;
   */
  arch: string;

  /**
   * @generated from field: repeated string supported_runtimes = 5;
   */
  supportedRuntimes: string[];
};

/**
 * Describes the message pinix.v2.RuntimeRegister.
 * Use `create(RuntimeRegisterSchema)` to create a new message.
 */
export const RuntimeRegisterSchema: GenMessage<RuntimeRegister> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 20);

/**
 * @generated from message pinix.v2.RuntimeRegisterResponse
 */
export type RuntimeRegisterResponse = Message<"pinix.v2.RuntimeRegisterResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message pinix.v2.RuntimeRegisterResponse.
 * Use `create(RuntimeRegisterResponseSchema)` to create a new message.
 */
export const RuntimeRegisterResponseSchema: GenMessage<RuntimeRegisterResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 21);

/**
 * @generated from message pinix.v2.InvokeCommand
 */
export type InvokeCommand = Message<"pinix.v2.InvokeCommand"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string clip_name = 2;
   */
  clipName: string;

  /**
   * @generated from field: string command = 3;
   */
  command: string;

  /**
   * @generated from field: bytes input = 4;
   */
  input: Uint8Array;

  /**
   * @generated from field: string clip_token = 5;
   */
  clipToken: string;
};

/**
 * Describes the message pinix.v2.InvokeCommand.
 * Use `create(InvokeCommandSchema)` to create a new message.
 */
export const InvokeCommandSchema: GenMessage<InvokeCommand> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 22);

/**
 * @generated from message pinix.v2.InvokeInput
 */
export type InvokeInput = Message<"pinix.v2.InvokeInput"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool done = 3;
   */
  done: boolean;
};

/**
 * Describes the message pinix.v2.InvokeInput.
 * Use `create(InvokeInputSchema)` to create a new message.
 */
export const InvokeInputSchema: GenMessage<InvokeInput> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 23);

/**
 * @generated from message pinix.v2.InstallCommand
 */
export type InstallCommand = Message<"pinix.v2.InstallCommand"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: string alias = 3;
   */
  alias: string;

  /**
   * @generated from field: string clip_token = 4;
   */
  clipToken: string;
};

/**
 * Describes the message pinix.v2.InstallCommand.
 * Use `create(InstallCommandSchema)` to create a new message.
 */
export const InstallCommandSchema: GenMessage<InstallCommand> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 24);

/**
 * @generated from message pinix.v2.InstallResult
 */
export type InstallResult = Message<"pinix.v2.InstallResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: pinix.v2.HubError error = 2;
   */
  error?: HubError;

  /**
   * @generated from field: pinix.v2.ClipInfo clip = 3;
   */
  clip?: ClipInfo;
};

/**
 * Describes the message pinix.v2.InstallResult.
 * Use `create(InstallResultSchema)` to create a new message.
 */
export const InstallResultSchema: GenMessage<InstallResult> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 25);

/**
 * @generated from message pinix.v2.RemoveCommand
 */
export type RemoveCommand = Message<"pinix.v2.RemoveCommand"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;
};

/**
 * Describes the message pinix.v2.RemoveCommand.
 * Use `create(RemoveCommandSchema)` to create a new message.
 */
export const RemoveCommandSchema: GenMessage<RemoveCommand> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 26);

/**
 * @generated from message pinix.v2.RemoveResult
 */
export type RemoveResult = Message<"pinix.v2.RemoveResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: pinix.v2.HubError error = 2;
   */
  error?: HubError;
};

/**
 * Describes the message pinix.v2.RemoveResult.
 * Use `create(RemoveResultSchema)` to create a new message.
 */
export const RemoveResultSchema: GenMessage<RemoveResult> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 27);

/**
 * @generated from message pinix.v2.Heartbeat
 */
export type Heartbeat = Message<"pinix.v2.Heartbeat"> & {
  /**
   * @generated from field: int64 sent_at_unix_ms = 1;
   */
  sentAtUnixMs: bigint;
};

/**
 * Describes the message pinix.v2.Heartbeat.
 * Use `create(HeartbeatSchema)` to create a new message.
 */
export const HeartbeatSchema: GenMessage<Heartbeat> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 28);

/**
 * @generated from message pinix.v2.ListClipsRequest
 */
export type ListClipsRequest = Message<"pinix.v2.ListClipsRequest"> & {
};

/**
 * Describes the message pinix.v2.ListClipsRequest.
 * Use `create(ListClipsRequestSchema)` to create a new message.
 */
export const ListClipsRequestSchema: GenMessage<ListClipsRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 29);

/**
 * @generated from message pinix.v2.ListClipsResponse
 */
export type ListClipsResponse = Message<"pinix.v2.ListClipsResponse"> & {
  /**
   * @generated from field: repeated pinix.v2.ClipInfo clips = 1;
   */
  clips: ClipInfo[];
};

/**
 * Describes the message pinix.v2.ListClipsResponse.
 * Use `create(ListClipsResponseSchema)` to create a new message.
 */
export const ListClipsResponseSchema: GenMessage<ListClipsResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 30);

/**
 * @generated from message pinix.v2.ListProvidersRequest
 */
export type ListProvidersRequest = Message<"pinix.v2.ListProvidersRequest"> & {
};

/**
 * Describes the message pinix.v2.ListProvidersRequest.
 * Use `create(ListProvidersRequestSchema)` to create a new message.
 */
export const ListProvidersRequestSchema: GenMessage<ListProvidersRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 31);

/**
 * @generated from message pinix.v2.ListProvidersResponse
 */
export type ListProvidersResponse = Message<"pinix.v2.ListProvidersResponse"> & {
  /**
   * @generated from field: repeated pinix.v2.ProviderInfo providers = 1;
   */
  providers: ProviderInfo[];
};

/**
 * Describes the message pinix.v2.ListProvidersResponse.
 * Use `create(ListProvidersResponseSchema)` to create a new message.
 */
export const ListProvidersResponseSchema: GenMessage<ListProvidersResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 32);

/**
 * @generated from message pinix.v2.GetManifestRequest
 */
export type GetManifestRequest = Message<"pinix.v2.GetManifestRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;
};

/**
 * Describes the message pinix.v2.GetManifestRequest.
 * Use `create(GetManifestRequestSchema)` to create a new message.
 */
export const GetManifestRequestSchema: GenMessage<GetManifestRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 33);

/**
 * @generated from message pinix.v2.GetManifestResponse
 */
export type GetManifestResponse = Message<"pinix.v2.GetManifestResponse"> & {
  /**
   * @generated from field: pinix.v2.ClipManifest manifest = 1;
   */
  manifest?: ClipManifest;
};

/**
 * Describes the message pinix.v2.GetManifestResponse.
 * Use `create(GetManifestResponseSchema)` to create a new message.
 */
export const GetManifestResponseSchema: GenMessage<GetManifestResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 34);

/**
 * @generated from message pinix.v2.GetClipWebRequest
 */
export type GetClipWebRequest = Message<"pinix.v2.GetClipWebRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from field: string if_none_match = 3;
   */
  ifNoneMatch: string;

  /**
   * @generated from field: int64 offset = 4;
   */
  offset: bigint;

  /**
   * @generated from field: int64 length = 5;
   */
  length: bigint;
};

/**
 * Describes the message pinix.v2.GetClipWebRequest.
 * Use `create(GetClipWebRequestSchema)` to create a new message.
 */
export const GetClipWebRequestSchema: GenMessage<GetClipWebRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 35);

/**
 * @generated from message pinix.v2.GetClipWebResponse
 */
export type GetClipWebResponse = Message<"pinix.v2.GetClipWebResponse"> & {
  /**
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string etag = 3;
   */
  etag: string;

  /**
   * @generated from field: bool not_modified = 4;
   */
  notModified: boolean;

  /**
   * @generated from field: int64 total_size = 5;
   */
  totalSize: bigint;
};

/**
 * Describes the message pinix.v2.GetClipWebResponse.
 * Use `create(GetClipWebResponseSchema)` to create a new message.
 */
export const GetClipWebResponseSchema: GenMessage<GetClipWebResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 36);

/**
 * @generated from message pinix.v2.InvokeRequest
 */
export type InvokeRequest = Message<"pinix.v2.InvokeRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * @generated from field: bytes input = 3;
   */
  input: Uint8Array;

  /**
   * @generated from field: string clip_token = 4;
   */
  clipToken: string;
};

/**
 * Describes the message pinix.v2.InvokeRequest.
 * Use `create(InvokeRequestSchema)` to create a new message.
 */
export const InvokeRequestSchema: GenMessage<InvokeRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 37);

/**
 * @generated from message pinix.v2.InvokeResponse
 */
export type InvokeResponse = Message<"pinix.v2.InvokeResponse"> & {
  /**
   * @generated from field: bytes output = 1;
   */
  output: Uint8Array;

  /**
   * @generated from field: pinix.v2.HubError error = 2;
   */
  error?: HubError;
};

/**
 * Describes the message pinix.v2.InvokeResponse.
 * Use `create(InvokeResponseSchema)` to create a new message.
 */
export const InvokeResponseSchema: GenMessage<InvokeResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 38);

/**
 * @generated from message pinix.v2.InvokeStreamMessage
 */
export type InvokeStreamMessage = Message<"pinix.v2.InvokeStreamMessage"> & {
  /**
   * @generated from oneof pinix.v2.InvokeStreamMessage.payload
   */
  payload: {
    /**
     * @generated from field: pinix.v2.InvokeRequest start = 1;
     */
    value: InvokeRequest;
    case: "start";
  } | {
    /**
     * @generated from field: pinix.v2.InputChunk chunk = 2;
     */
    value: InputChunk;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message pinix.v2.InvokeStreamMessage.
 * Use `create(InvokeStreamMessageSchema)` to create a new message.
 */
export const InvokeStreamMessageSchema: GenMessage<InvokeStreamMessage> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 39);

/**
 * @generated from message pinix.v2.InputChunk
 */
export type InputChunk = Message<"pinix.v2.InputChunk"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool done = 2;
   */
  done: boolean;
};

/**
 * Describes the message pinix.v2.InputChunk.
 * Use `create(InputChunkSchema)` to create a new message.
 */
export const InputChunkSchema: GenMessage<InputChunk> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 40);

/**
 * @generated from message pinix.v2.AddClipRequest
 */
export type AddClipRequest = Message<"pinix.v2.AddClipRequest"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string clip_token = 4;
   */
  clipToken: string;

  /**
   * @generated from field: string requested_alias = 5;
   */
  requestedAlias: string;
};

/**
 * Describes the message pinix.v2.AddClipRequest.
 * Use `create(AddClipRequestSchema)` to create a new message.
 */
export const AddClipRequestSchema: GenMessage<AddClipRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 41);

/**
 * @generated from message pinix.v2.AddClipResponse
 */
export type AddClipResponse = Message<"pinix.v2.AddClipResponse"> & {
  /**
   * @generated from field: pinix.v2.ClipInfo clip = 1;
   */
  clip?: ClipInfo;
};

/**
 * Describes the message pinix.v2.AddClipResponse.
 * Use `create(AddClipResponseSchema)` to create a new message.
 */
export const AddClipResponseSchema: GenMessage<AddClipResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 42);

/**
 * @generated from message pinix.v2.RemoveClipRequest
 */
export type RemoveClipRequest = Message<"pinix.v2.RemoveClipRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * @generated from field: bool purge = 2;
   */
  purge: boolean;
};

/**
 * Describes the message pinix.v2.RemoveClipRequest.
 * Use `create(RemoveClipRequestSchema)` to create a new message.
 */
export const RemoveClipRequestSchema: GenMessage<RemoveClipRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 43);

/**
 * @generated from message pinix.v2.RemoveClipResponse
 */
export type RemoveClipResponse = Message<"pinix.v2.RemoveClipResponse"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;
};

/**
 * Describes the message pinix.v2.RemoveClipResponse.
 * Use `create(RemoveClipResponseSchema)` to create a new message.
 */
export const RemoveClipResponseSchema: GenMessage<RemoveClipResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 44);

/**
 * @generated from message pinix.v2.GetBindingsRequest
 */
export type GetBindingsRequest = Message<"pinix.v2.GetBindingsRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;
};

/**
 * Describes the message pinix.v2.GetBindingsRequest.
 * Use `create(GetBindingsRequestSchema)` to create a new message.
 */
export const GetBindingsRequestSchema: GenMessage<GetBindingsRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 45);

/**
 * @generated from message pinix.v2.GetBindingsResponse
 */
export type GetBindingsResponse = Message<"pinix.v2.GetBindingsResponse"> & {
  /**
   * @generated from field: map<string, pinix.v2.ClipBinding> bindings = 1;
   */
  bindings: { [key: string]: ClipBinding };

  /**
   * @generated from field: map<string, pinix.v2.DependencySlot> dependency_slots = 2;
   */
  dependencySlots: { [key: string]: DependencySlot };
};

/**
 * Describes the message pinix.v2.GetBindingsResponse.
 * Use `create(GetBindingsResponseSchema)` to create a new message.
 */
export const GetBindingsResponseSchema: GenMessage<GetBindingsResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 46);

/**
 * @generated from message pinix.v2.SetBindingRequest
 */
export type SetBindingRequest = Message<"pinix.v2.SetBindingRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * @generated from field: string slot = 2;
   */
  slot: string;

  /**
   * @generated from field: pinix.v2.ClipBinding binding = 3;
   */
  binding?: ClipBinding;
};

/**
 * Describes the message pinix.v2.SetBindingRequest.
 * Use `create(SetBindingRequestSchema)` to create a new message.
 */
export const SetBindingRequestSchema: GenMessage<SetBindingRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 47);

/**
 * @generated from message pinix.v2.SetBindingResponse
 */
export type SetBindingResponse = Message<"pinix.v2.SetBindingResponse"> & {
};

/**
 * Describes the message pinix.v2.SetBindingResponse.
 * Use `create(SetBindingResponseSchema)` to create a new message.
 */
export const SetBindingResponseSchema: GenMessage<SetBindingResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 48);

/**
 * @generated from message pinix.v2.RemoveBindingRequest
 */
export type RemoveBindingRequest = Message<"pinix.v2.RemoveBindingRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * @generated from field: string slot = 2;
   */
  slot: string;
};

/**
 * Describes the message pinix.v2.RemoveBindingRequest.
 * Use `create(RemoveBindingRequestSchema)` to create a new message.
 */
export const RemoveBindingRequestSchema: GenMessage<RemoveBindingRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 49);

/**
 * @generated from message pinix.v2.RemoveBindingResponse
 */
export type RemoveBindingResponse = Message<"pinix.v2.RemoveBindingResponse"> & {
};

/**
 * Describes the message pinix.v2.RemoveBindingResponse.
 * Use `create(RemoveBindingResponseSchema)` to create a new message.
 */
export const RemoveBindingResponseSchema: GenMessage<RemoveBindingResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 50);

/**
 * Client → Hub
 *
 * @generated from message pinix.v2.DataRequest
 */
export type DataRequest = Message<"pinix.v2.DataRequest"> & {
  /**
   * @generated from field: string clip_name = 1;
   */
  clipName: string;

  /**
   * "read" | "write" | "list" | "delete" | "stat"
   *
   * @generated from field: string operation = 2;
   */
  operation: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * write only
   *
   * @generated from field: bytes content = 4;
   */
  content: Uint8Array;

  /**
   * write only
   *
   * @generated from field: string mime = 5;
   */
  mime: string;

  /**
   * @generated from field: string clip_token = 6;
   */
  clipToken: string;
};

/**
 * Describes the message pinix.v2.DataRequest.
 * Use `create(DataRequestSchema)` to create a new message.
 */
export const DataRequestSchema: GenMessage<DataRequest> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 51);

/**
 * @generated from message pinix.v2.DataResponse
 */
export type DataResponse = Message<"pinix.v2.DataResponse"> & {
  /**
   * read only
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * write returns pinix://{clip}/{path}
   *
   * @generated from field: string uri = 2;
   */
  uri: string;

  /**
   * list only
   *
   * @generated from field: repeated pinix.v2.DataEntry entries = 3;
   */
  entries: DataEntry[];

  /**
   * stat only
   *
   * @generated from field: pinix.v2.DataStat stat = 4;
   */
  stat?: DataStat;

  /**
   * @generated from field: pinix.v2.HubError error = 5;
   */
  error?: HubError;
};

/**
 * Describes the message pinix.v2.DataResponse.
 * Use `create(DataResponseSchema)` to create a new message.
 */
export const DataResponseSchema: GenMessage<DataResponse> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 52);

/**
 * @generated from message pinix.v2.DataEntry
 */
export type DataEntry = Message<"pinix.v2.DataEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * pinix:// URI
   *
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * "file" | "directory"
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: int64 size = 4;
   */
  size: bigint;

  /**
   * @generated from field: string mime = 5;
   */
  mime: string;
};

/**
 * Describes the message pinix.v2.DataEntry.
 * Use `create(DataEntrySchema)` to create a new message.
 */
export const DataEntrySchema: GenMessage<DataEntry> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 53);

/**
 * @generated from message pinix.v2.DataStat
 */
export type DataStat = Message<"pinix.v2.DataStat"> & {
  /**
   * @generated from field: int64 size = 1;
   */
  size: bigint;

  /**
   * @generated from field: string mime = 2;
   */
  mime: string;

  /**
   * ISO 8601
   *
   * @generated from field: string modified = 3;
   */
  modified: string;
};

/**
 * Describes the message pinix.v2.DataStat.
 * Use `create(DataStatSchema)` to create a new message.
 */
export const DataStatSchema: GenMessage<DataStat> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 54);

/**
 * Hub → Provider (via ProviderStream)
 *
 * @generated from message pinix.v2.DataCommand
 */
export type DataCommand = Message<"pinix.v2.DataCommand"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string clip_name = 2;
   */
  clipName: string;

  /**
   * @generated from field: string operation = 3;
   */
  operation: string;

  /**
   * @generated from field: string path = 4;
   */
  path: string;

  /**
   * @generated from field: bytes content = 5;
   */
  content: Uint8Array;

  /**
   * @generated from field: string mime = 6;
   */
  mime: string;
};

/**
 * Describes the message pinix.v2.DataCommand.
 * Use `create(DataCommandSchema)` to create a new message.
 */
export const DataCommandSchema: GenMessage<DataCommand> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 55);

/**
 * Provider → Hub (via ProviderStream)
 *
 * @generated from message pinix.v2.DataResult
 */
export type DataResult = Message<"pinix.v2.DataResult"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * @generated from field: string uri = 3;
   */
  uri: string;

  /**
   * @generated from field: repeated pinix.v2.DataEntry entries = 4;
   */
  entries: DataEntry[];

  /**
   * @generated from field: pinix.v2.DataStat stat = 5;
   */
  stat?: DataStat;

  /**
   * @generated from field: pinix.v2.HubError error = 6;
   */
  error?: HubError;
};

/**
 * Describes the message pinix.v2.DataResult.
 * Use `create(DataResultSchema)` to create a new message.
 */
export const DataResultSchema: GenMessage<DataResult> = /*@__PURE__*/
  messageDesc(file_pinix_v2_hub, 56);

/**
 * Hub 路由表中的 Clip 条目。
 * 出现在列表里 = 可用，不存在离线概念。
 *
 * @generated from enum pinix.v2.ClipStatus
 */
export enum ClipStatus {
  /**
   * @generated from enum value: CLIP_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLIP_STATUS_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: CLIP_STATUS_SLEEPING = 2;
   */
  SLEEPING = 2,

  /**
   * @generated from enum value: CLIP_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum pinix.v2.ClipStatus.
 */
export const ClipStatusSchema: GenEnum<ClipStatus> = /*@__PURE__*/
  enumDesc(file_pinix_v2_hub, 0);

/**
 * @generated from service pinix.v2.HubService
 */
export const HubService: GenService<{
  /**
   * 所有 Provider（Runtime / Edge Clip）统一协议。
   *
   * @generated from rpc pinix.v2.HubService.ProviderStream
   */
  providerStream: {
    methodKind: "bidi_streaming";
    input: typeof ProviderMessageSchema;
    output: typeof HubMessageSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.RuntimeStream
   */
  runtimeStream: {
    methodKind: "bidi_streaming";
    input: typeof RuntimeMessageSchema;
    output: typeof HubRuntimeMessageSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.ListClips
   */
  listClips: {
    methodKind: "unary";
    input: typeof ListClipsRequestSchema;
    output: typeof ListClipsResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.ListProviders
   */
  listProviders: {
    methodKind: "unary";
    input: typeof ListProvidersRequestSchema;
    output: typeof ListProvidersResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.GetManifest
   */
  getManifest: {
    methodKind: "unary";
    input: typeof GetManifestRequestSchema;
    output: typeof GetManifestResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.GetClipWeb
   */
  getClipWeb: {
    methodKind: "unary";
    input: typeof GetClipWebRequestSchema;
    output: typeof GetClipWebResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.Invoke
   */
  invoke: {
    methodKind: "server_streaming";
    input: typeof InvokeRequestSchema;
    output: typeof InvokeResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.InvokeStream
   */
  invokeStream: {
    methodKind: "bidi_streaming";
    input: typeof InvokeStreamMessageSchema;
    output: typeof InvokeResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.Data
   */
  data: {
    methodKind: "unary";
    input: typeof DataRequestSchema;
    output: typeof DataResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.AddClip
   */
  addClip: {
    methodKind: "unary";
    input: typeof AddClipRequestSchema;
    output: typeof AddClipResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.RemoveClip
   */
  removeClip: {
    methodKind: "unary";
    input: typeof RemoveClipRequestSchema;
    output: typeof RemoveClipResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.GetBindings
   */
  getBindings: {
    methodKind: "unary";
    input: typeof GetBindingsRequestSchema;
    output: typeof GetBindingsResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.SetBinding
   */
  setBinding: {
    methodKind: "unary";
    input: typeof SetBindingRequestSchema;
    output: typeof SetBindingResponseSchema;
  },
  /**
   * @generated from rpc pinix.v2.HubService.RemoveBinding
   */
  removeBinding: {
    methodKind: "unary";
    input: typeof RemoveBindingRequestSchema;
    output: typeof RemoveBindingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pinix_v2_hub, 0);

